module.exports = __webpack_public_path__ + "img/video-2-tmb.3f509650.png";